import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-image-upload',
  standalone: false,
  templateUrl: './image-upload.component.html',
  styleUrl: './image-upload.component.scss',
})
export class ImageUploadComponent implements OnChanges {
  @Input() height: number = 0;
  @Input() width: number = 0;
  @Input() size: number = 2;
  @Input() selectedImage: string = '';
  @Input() browseText: string = '';
  @Input() eventImage: boolean = false;
  @Input() showRemove: boolean = false;
  @Input() key: number = 0;
  @Input() disabled: boolean = false;
  @Input() allowSvg: boolean = false;
  @Output() fileSelected = new EventEmitter<File | null>();
  @Output() imageRemoved = new EventEmitter<void>();
  @Output() fileRemoved = new EventEmitter<void>();
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;

  isDragging = false;
  errorMessage: string | null = null;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['key']?.currentValue > 0) {
      this.resetComponent();
    }
  }
  resetComponent(): void {
    this.errorMessage = null;
    this.selectedImage = '';
    this.eventImage = false;
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer?.files.length) {
      this.onDropFileValidation(event);
    }
  }

  onClickFileValidation(event: Event) {
    const target = event.target as HTMLInputElement;
    const validTypes = this.allowSvg
      ? ['image/jpeg', 'image/png', 'image/svg+xml']
      : ['image/jpeg', 'image/png'];
    if (target.files?.length) {
      const file = target.files[0];

      if (!validTypes.includes(file.type)) {
        this.errorMessage = this.allowSvg
          ? 'Only JPG, PNG and SVG files are allowed.'
          : 'Only JPG and PNG files are allowed.';
        target.value = '';
        return;
      }
      if (file.size > this.size * 1048576) {
        this.errorMessage = `File size must be less than ${this.size} MB.`;
        return;
      }
      this.onFileSelected(file);
    }
  }

  onDropFileValidation(event: DragEvent) {
    const validTypes = this.allowSvg
      ? ['image/jpeg', 'image/png', 'image/svg+xml']
      : ['image/jpeg', 'image/png'];

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];

      if (!validTypes.includes(file.type)) {
        this.errorMessage = this.allowSvg
          ? 'Only JPG, PNG and SVG files are allowed.'
          : 'Only JPG and PNG files are allowed.';
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
        return;
      }
      if (file.size > this.size * 1048576) {
        this.errorMessage = `File size must be less than ${this.size} MB.`;
        return;
      }
      this.onFileSelected(file);
    }
  }

  onFileSelected(file: any): void {
    // Validate file dimensions for all image types (PNG, JPG, SVG)
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {

        // if (img.width != this.width || img.height != this.height) {
        //   this.errorMessage = `Image must be ${this.width}x${this.height}px.`;
        // } else {
        //   this.errorMessage = null;
        //   this.loadImagePreview(file); // Load preview if valid
        //   this.fileSelected.emit(file); // Emit valid file
        // }
        if (this.width > 0 && this.height > 0) {
          if (img.width !== this.width || img.height !== this.height) {
            this.errorMessage = `Image must be ${this.width}x${this.height}px.`;
            return;
          }
        } else if (this.height > 0 && this.width === 0) {
          if (img.height !== this.height) {
            this.errorMessage = `Image height must be ${this.height}px.`;
            return;
          }
        } else if (this.width > 0 && this.height === 0) {
          if (img.width !== this.width) {
            this.errorMessage = `Image width must be ${this.width}px.`;
            return;
          }
        }

        this.errorMessage = null;
        this.loadImagePreview(file);  // Load preview if valid
        this.fileSelected.emit(file); // Emit valid file
      };
      img.onerror = () => {
        this.errorMessage = 'Invalid image file.';
      };
      img.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  private loadImagePreview(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.selectedImage = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  removeImage(event: MouseEvent) {
    event.stopPropagation();
    this.selectedImage = '';
    this.errorMessage = null;

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.fileSelected.emit(null);
    this.imageRemoved.emit();
    //this.fileRemoved.emit();
  }
}
